// src/components/Testimonials.js
import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Section = styled.section`
  padding: 5rem 2rem;
  background-color: #f8fafc;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 3rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

const Card = styled(motion.div)`
  background: white;
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
  border-left: 5px solid ${props => props.theme.colors.secondary};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Quote = styled.p`
  font-style: italic;
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const Author = styled.p`
  font-weight: bold;
  color: ${props => props.theme.colors.primary};
  font-size: 0.9rem;
`;

const Role = styled.span`
  display: block;
  font-weight: normal;
  color: #9ca3af;
  font-size: 0.8rem;
  margin-top: 0.2rem;
`;

const testimonialData = [
  {
    text: "At L&J Agape, we view our work through the lens of professional duty and deep responsibility. The joy and happiness of our clients is our own joy; seeing them thrive is our greatest fulfillment.",
    author: "O. Abigail",
    role: "Manager, L&J Agape Healthcare"
  },
  {
    text: "Working here is more than a job; it's a calling of willing service. I truly look forward to every shift and the chance to volunteer my best. If you want to work somewhere that changes lives, join us!",
    author: "T.N. Isabella",
    role: "Care Professional"
  },
  {
    text: "L&J Agape provided wonderful care for my mother during a very difficult time. The staff are professional, kind, and truly care about maintaining her dignity.",
    author: "Anonymous",
    role: "Family Member, Willenhall"
  },
  {
    text: "The agency staff provided were top-notch. They hit the ground running and were a huge help to our care home team during a critical staffing shortage.",
    author: "Sarah J.",
    role: "Care Home Manager, Wolverhampton"
  },
  {
    text: "I highly recommend their mental health support services. They truly listen and provide personalized care that makes a real difference in daily wellbeing.",
    author: "D. Thompson",
    role: "Service User"
  }
];

const Testimonials = () => {
  return (
    <Section id="testimonials">
      <Container>
        <Title>Voices of Care & Excellence</Title>
        <Grid>
          {testimonialData.map((item, index) => (
            <Card 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Quote>"{item.text}"</Quote>
              <Author>
                {item.author} 
                <Role>{item.role}</Role>
              </Author>
            </Card>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default Testimonials;